import React, { useEffect, useState } from "react";
import {Table as AntTable,Button,Col,message,Pagination,Popconfirm,Row,notification,Form,Modal,Switch,Input,
} from "antd";
import Table, { ColumnsType } from "antd/es/table";
import { SearchOutlined } from "@ant-design/icons";
import { Link, useNavigate, useLocation } from "react-router-dom";
//  import { useLocation } from "react-router-dom";
import {components,formattedTimeRange,getRowClassName} from "../../utils/utils";
import IMAGES from "../../const/Image";
import Search from "antd/es/input/Search";
// import { SalonFilter } from "./SalonFilter";
import { FaSliders } from "react-icons/fa6";
import { Space, Tooltip } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import SalonRequest from "../Salons/SalonRequest";
import { Tabs } from "antd";
import AppoinmentRequest from "./AppoinmentService";
import { AppoinmentsFilter } from "./AppoinmentsFilter";
import { Tag } from "antd";
import {  useParams } from "react-router-dom";

import { usePermission } from "../../hooks/usePermission";
const onChange = (key) => {
  // console.log(key);
};

const confirm = (e) => {
  // console.log(e);
  message.success("Deleted!");
};

const Appointments = () => {
    const hasListPermission = usePermission("Appointments", "List");
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const location = useLocation()
  const onSearch = (value, _e, info) => console.log(info?.source, value);
  const showConfirm = Modal.confirm;
  const [isModalOpen, setIsModalOpen] = useState(false);
  // const [labList, setLabList] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [appointmentData, setAppoinmentData] = useState([]);
  const { salonId, id } = useParams();
  const [activeTab, setActiveTab] = useState(location.state?.activeTab || '1');
  const [filterForm, setFilterForm] = useState({});
  const initialFilter = {
    page: 1,
  };
  const [filter, setFilter] = useState(initialFilter);
  const [filteredAppointments, setFilteredAppointments] = useState([]);
  console.log("filterForm444", activeTab);
  console.log("salonId", salonId);

  
  const fetchAppoinmentList = () => {
    setLoading(true);
    console.log("activeTabdddd,=", activeTab);
    AppoinmentRequest.appoinmentList({ ...filter, type: activeTab })
      .then((response) => {
        const rawData = response?.data?.data?.data || [];
        // console.log(rawData)
        const totalCount = response?.data?.totalCount || 0;
        setAppoinmentData(rawData);
        setFilteredAppointments(rawData);
        // setTotalRecords(totalCount)
        setTotalRecords(response?.data?.data?.totalItems || rawData.length);
      })
      .catch((error) => {
        // message.error("Failed to fetch appointment list")
        console.log("error", error);
        setAppoinmentData([]);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if(hasListPermission){
    fetchAppoinmentList();
    }

  }, [filter , hasListPermission]);

  const handleFilter = () => {
    setFilter({ ...filter, ...filterForm, ...initialFilter });
    console.log("filter", filter);
    console.log("filterForm33", filterForm);

    setIsModalOpen(false);
  };


  const tab = (key) => {
    console.log("rrrr====", key);
    setActiveTab(key);
    if (key) {
      AppoinmentRequest.appoinmentList({ ...filter, type: key })
        .then((response) => {
          const rawData = response?.data?.data?.data || [];
          // console.log(rawData)
          const totalCount = response?.data?.totalCount || 0;
          setAppoinmentData(rawData);
          setFilteredAppointments(rawData);
          // setTotalRecords(totalCount)
          setTotalRecords(response?.data?.data?.totalItems || rawData.length);
        })
        .catch((error) => {
          // message.error("Failed to fetch appointment list")
          console.log("error", error);
          setAppoinmentData([]);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  // const handleChange = (pagination) => {
  //   setFilter((prev) => ({
  //     ...prev,
  //     page: pagination.current, // Update current page from pagination event
  //   }));
  // };

  const handleChange = (pagination) => {
    setFilter((prev) => ({
      ...prev,
      page: pagination.current, // Ensure it updates correctly
    }));
  };

  const resetFilters = () => {
    form.resetFields();
    setFilterForm({});
    setFilter(initialFilter);
  };

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const columns = (navigate) => [
    {
      title: "S No.",
      dataIndex: "id",
      key: "id",
      width: "60px",
      render: (value, item, index) => (filter?.page - 1) * 10 + index + 1,
    },
    {
      title: "Appointment ID",
      dataIndex: "appointmentId",
      key: "appointmentId",
      width: "200px",
    },
    {
      title: "Salon Name",
      dataIndex: "salon",
      key: "salon",
      width: "200px",
      render: (text, item, record) => {
        return (
          <a
            // onClick={() =>navigate(`/salons/details/${record.salonId}`)}
            // style={{ color: "#1890ff", cursor: "pointer", fontSize: "17px" }}
          >
            {text[0]?.salonName}
          </a>
        );
      },
    },

    {
      title: "Slot Details",
      dataIndex: "services",
      key: "services",
      width: "200px",
      render: (services, record) => {
        if (!services || services.length === 0) {
          return "No slot details available";
        }
        return (
          <div>
            <div> {record.date}</div>
            {services.map((service, index) => (
              <div key={index}>
                {service?.slot?.startTime} - {service?.slot?.endTime}
              </div>
            ))}
          </div>
        );
      },
    },
    {
      title: "Services",
      dataIndex: "services",
      key: "services",
      width: "200px",
      render: (services) => {
        return (
          <div>
            {services.map((service, index) => (
              <div key={index}>{service?.serviceName}</div>
            ))}
          </div>
        );
      },
    },
    // {
    //   title: "Customer Name",
    //   dataIndex: "user",
    //   key: "user",
    //   width: "200px",
    //   render: (text) => {
    //     return <div>{text?.name}</div>;
    //   },
    // },
    {
      title: "Contact Person",
      dataIndex: "user",
      key: "user",
      width: "200px",
      render: (contact) => (
        <div>
          <div> {contact?.name}</div>
          <div>{contact?.mobile}</div>
        </div>
      ),
    },
    {
      title: "Visit Type",
      dataIndex: "appointmentservice",
      key: "appointmentservice",
      width: "160px",
      render: (value, data) => {
        const salon = data?.visitType;
        if (salon === 0) return "Home ";
        if (salon === 1) return "Salon ";
        if (salon === 2) return "Both";
      },
    },
    {
      title: "Booking Date",
      dataIndex: "date",
      key: "date",
      width: "160px",
      // render: (value, data) => {
      //   const salon = data?.visitType
      //   if (salon === 0) return "Home ";
      //   if (salon === 1) return "Salon ";
      //   if (salon === 2) return "Both"
      // }
    },

    // {
    //   title: "Status",
    //   dataIndex: "status",
    //   width: 120,
    //   align: "center",
    //   render: (is_active, item) => (
    //     // <Switch
    //     //   checked={is_active === 1}
    //     //   checkedChildren="Approved"
    //     //   unCheckedChildren="Cancelled"
    //     // // onChange={(checked) => handleStatusChange(checked, item)}
    //     // />
    //     <Tag color="red" checked={is_active === 1}
    //     checkedChildren="Approved"
    //     unCheckedChildren="Cancelled"></Tag>
    //   ),
    // },

    {
      title: "Status",
      dataIndex: "status",
      width: 120,
      align: "center",
      render: (status) => {
        const statusMap = {
          0: { color: "orange", text: "Pending" },
          1: { color: "blue", text: "Booking Confirmed" },
          2: { color: "red", text: "Rejected" },
          3: { color: "purple", text: "Service Started" },
          4: { color: "green", text: "Completed" },
          6: { color: "red", text: "Cancelled" },
        };

        return (
          <Tag color={statusMap[status]?.color}>{statusMap[status]?.text}</Tag>
        );
      },
    },

    {
      title: "Action",
      dataIndex: "appointmentId",
      key: "appointmentId",
      width: "200px",
      render: (_, record) => {
        return (
          <Space size="middle">
            <Tooltip
              title="View Details"
              style={{ color: "red", cursor: "pointer" }}
            >
              <span
                className="action-icon-bg"
                onClick={() =>
                  navigate(`/appoinments/view/${record?.appointmentId}`)
                }
              >
                <img src={IMAGES.ViewIcon} />
              </span>
            </Tooltip>
          </Space>
        );
      },
    },
    // Add other columns as needed
  ];

  const items = [
    {
      key: "1",
      label: "All",
      children: (
        <div style={{}}>
          <Table
            size="middle"
            bordered
            rowClassName={getRowClassName}
            components={components}
            columns={columns(navigate)}
            loading={loading}
            onChange={handleChange}
            dataSource={appointmentData}
            pagination={{
              total: totalRecords, // Ensure this value updates correctly
              current: filter?.page, // Ensure this updates with state
              pageSize: 10, // Keep it fixed
              showSizeChanger: false,
              showTotal: (total, range) =>
                `${range[0]}-${range[1]} of ${total} items`,
              onChange: (page) => {
                setFilter((prev) => ({ ...prev, page })); // Ensure page updates
                fetchAppoinmentList({ ...filter, page }); // Refetch data
              },
            }}
            scroll={{ x: "max-content" }}
          />
        </div>
      ),
    },
    {
      key: "2",
      label: "Upcomings",
      children: (
        <div style={{}}>
          <Table
            size="middle"
            bordered
            rowClassName={getRowClassName}
            components={components}
            columns={columns(navigate)}
            loading={loading}
            onChange={handleChange}
            dataSource={appointmentData}
            // dataSource={appointmentData.filter((item) => item.type === 2)}
            pagination={{
              total: totalRecords, // Total items from API
              current: filter?.page, // Current page from API
              pageSize: 10, // Keep it fixed to 10 as per API request
              showSizeChanger: false, // Disable changing page size
              showTotal: (total, range) =>
                `${range[0]}-${range[1]} of ${total} items`,
              onChange: (page) => setFilter((prev) => ({ ...prev, page })), // Ensure correct page change
            }}
            scroll={{ x: "max-content" }}
          />
        </div>
      ),
    },
    {
      key: "3",
      label: "Today's",
      children: (
        <div style={{}}>
          <Table
            size="middle"
            bordered
            rowClassName={getRowClassName}
            components={components}
            columns={columns(navigate)}
            loading={loading}
            onChange={handleChange}
            dataSource={appointmentData}
            // dataSource={appointmentData.filter((item) => item.type === 3)}
            pagination={{
              total: totalRecords, // Total items from API
              current: filter?.page, // Current page from API
              pageSize: 10, // Keep it fixed to 10 as per API request
              showSizeChanger: false, // Disable changing page size
              showTotal: (total, range) =>
                `${range[0]}-${range[1]} of ${total} items`,
              onChange: (page) => setFilter((prev) => ({ ...prev, page })), // Ensure correct page change
            }}
            scroll={{ x: "max-content" }}
          />
        </div>
      ),
    },
    {
      key: "4",
      label: "Cancelled",
      children: (
        <div style={{}}>
          <Table
            size="middle"
            bordered
            rowClassName={getRowClassName}
            components={components}
            columns={columns(navigate)}
            loading={loading}
            onChange={handleChange}
            dataSource={appointmentData}
            // dataSource={appointmentData.filter((item) => item.status === 2)}
            pagination={{
              total: totalRecords, // Total items from API
              current: filter?.page, // Current page from API
              pageSize: 10, // Keep it fixed to 10 as per API request
              showSizeChanger: false, // Disable changing page size
              showTotal: (total, range) =>
                `${range[0]}-${range[1]} of ${total} items`,
              onChange: (page) => setFilter((prev) => ({ ...prev, page })), // Ensure correct page change
            }}
            scroll={{ x: "max-content" }}
          />
        </div>
      ),
    },

    {
      key: "5",
      label: "Completed",
      children: (
        <div style={{}}>
          <Table
            size="middle"
            bordered
            rowClassName={getRowClassName}
            components={components}
            columns={columns(navigate)}
            loading={loading}
            onChange={handleChange}
            dataSource={appointmentData}
            // dataSource={appointmentData.filter((item) => item.status === 1)}
            pagination={{
              total: totalRecords, // Total items from API
              current: filter?.page, // Current page from API
              pageSize: 10, // Keep it fixed to 10 as per API request
              showSizeChanger: false, // Disable changing page size
              showTotal: (total, range) =>
                `${range[0]}-${range[1]} of ${total} items`,
              onChange: (page) => setFilter((prev) => ({ ...prev, page })), // Ensure correct page change
            }}
            scroll={{ x: "max-content" }}
          />
        </div>
      ),
    },
    {
      key: "6",
      label: "Pending",
      children: (
        <div style={{}}>
          <Table
            size="middle"
            bordered
            rowClassName={getRowClassName}
            components={components}
            columns={columns(navigate)}
            loading={loading}
            onChange={handleChange}
            dataSource={appointmentData}
            // dataSource={appointmentData.filter((item) => item.status === 0)}
            pagination={{
              total: totalRecords, // Total items from API
              current: filter?.page, // Current page from API
              pageSize: 10, // Keep it fixed to 10 as per API request
              showSizeChanger: false, // Disable changing page size
              showTotal: (total, range) =>
                `${range[0]}-${range[1]} of ${total} items`,
              onChange: (page) => setFilter((prev) => ({ ...prev, page })), // Ensure correct page change
            }}
            scroll={{ x: "max-content" }}
          />
        </div>
      ),
    },
  ];

  const handleStatusChange = (checked, item) => {
    if (!item.salonId) {
      notification.error({
        message: "Salon ID is required to update status.",
      });
      return;
    }
  };

  return (
    <>
      <div className="">
        <Row gutter={[8, 8]} justify="space-between" align="middle">
          <Col>
            <h1 className="app-heading-med">Appointments</h1>
          </Col>
          <Col style={{ gap: "1rem", display: "flex" }}>
            {/* <div> */}
            <Input
              placeholder="Search by salon name , appointment id"
              size="large"
              className="FilterSearchBox"
              onChange={(e) =>
                setFilterForm({ ...filterForm, search: e.target.value })
              }
              value={filterForm?.search}
              style={{ width: "100%" }}
              onKeyPress={(e) => {
                if (e.key === "Enter") {
                  handleFilter();
                }
              }}
            />
            <Button
              onClick={handleFilter}
              type="primary"
              htmlType="submit"
              className="addcity-btn"
              style={{ height: "39px" }}
            >
              <SearchOutlined />
            </Button>

            <Button
              type="primary"
              className="addcity-btn"
              onClick={resetFilters}
              style={{ height: "39px" }}
            >
              Reset
            </Button>

            <Button
              onClick={() => showModal()}
              type="primary"
              htmlType="submit"
              className="addcity-btn"
              style={{ height: "39px" }}
            >
              <FaSliders />
            </Button>
            {/* </div> */}
          </Col>
        </Row>
      </div>
      <Tabs
        // defaultActiveKey={activeTab}
        // items={items}
        // onChange={(items) => tab(items)}

        activeKey={activeTab}
        items = {items}
        onChange={(key) =>{
          setActiveTab(key)
          tab(key)
        }}
      />

      <AppoinmentsFilter
        handleFilter={handleFilter}
        form={form}
        filterForm={filterForm}
        setFilterForm={setFilterForm}
        isModalOpen={isModalOpen}
        handleCancel={handleCancel}
      />
    </>
  );
};

export default Appointments;
